import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import FemaleApple from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/female-apple.svg'
import FemaleHourglass from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/female-hourglass.svg'
import FemalePear from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/female-pear.svg'
import FemaleRectangle from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/female-rectangle.svg'
import FemaleTriangle from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/female-triangle.svg'
import MaleInvertedTriangle from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/male-inverted-triangle.svg'
import MaleOval from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/male-oval.svg'
import MaleRectangle from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/male-rectangle.svg'
import MaleTriangle from 'page/ProfileScreen/BasicSelfiesPanel/asset/shape/male-triangle.svg'
import { FC, SVGProps } from 'react'
import { store } from 'store/store'
import { ShapeType } from 'type/Identity'
import css from './Shape.module.scss'

type Props = {
  shape: ShapeType
}

function getImage(type: ShapeType, male: boolean): FC<SVGProps<any>> | undefined {
  if (type === 'apple') return FemaleApple
  if (type === 'hourglass') return FemaleHourglass
  if (type === 'inverted triangle') return MaleInvertedTriangle
  if (type === 'oval') return MaleOval
  if (type === 'pear') return FemalePear
  if (type === 'rectangle') return male ? MaleRectangle : FemaleRectangle
  if (type === 'triangle') return male ? MaleTriangle : FemaleTriangle
}

export const Shape = observer(({ shape }: Props) => {
  const basic = store.profile.basic
  const selected = shape === basic.shape
  const className = clsx(css.item, selected && css.selected)
  const Svg = getImage(shape, basic.gender === 'male')

  const onClick = useLatestCallback(() => {
    basic.shape = shape
  })

  return <Space className={className} center onClick={onClick}>
    {Svg && <Svg />}
  </Space>
})
